import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/scent-taxonomy")({
  component: lazyRouteComponent(() => import("./-pages/admin.scent-taxonomy")),
  head: () => ({
    meta: [
      { title: "Scent Taxonomy · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
